import { get } from 'lodash';
import envConfig from '../../static/config';
import config from '../config';
import ApiUtils from './ApiUtils';
import UserManagementStore from '../stores/UserManagementStore';
import {
  handleMTrackConsentCreateError,
  handleMTrackConsentCreateSuccess,
  handleMTrackConsentedError,
  handleMTrackConsentedSuccess,
  handleMTrackEnabledError,
  handleMTrackEnabledSuccess,
} from '../actions/MTrackActionCreator';

const mTrackWhitelistEndpoint = '/ibapi/v2/business/mtrack/status';
const mTrackConsentEndpoint = '/ibapi/v2/clients/getconsent';
const mTrackCreateConsentEndpoint = '/ibapi/v2/clients/createconsent';

const APIPath = '/ibapi/v2/tpauth/token';

/**
 * Retrieve user details from state required
 * by the third party API endpoints
 */
function getUserDetails() {
  const user = UserManagementStore.getCADetails();
  const { customers, id } = user;

  return {
    // USER is hardcoded
    context: 'USER',
    userId: id,
    // TODO: post-MVP may need to select from many customer IDs
    corporateId: get(customers, '[0].customer_id'),
  };
}

export async function getWhitelistStatus(/*partnerCode = 'NINESPOKES'*/) {
  const { corporateId } = getUserDetails();

  const url = `${
    envConfig.isStubsEnabled
      ? envConfig.apiBaseUrlStub
      : envConfig.apiBaseUrlBusiness
  }${mTrackWhitelistEndpoint}/${corporateId}`;

  ApiUtils.makeAjaxCall(
    {
      apiVersion: config.apiVersions.authServices,
      method: 'GET',
      url,
      addAuthToken: true,
    },
    (body) => {
      if (body.data.consent) {
        handleMTrackEnabledSuccess(body.data.consent);
      } else {
        handleMTrackEnabledError();
      }
    },
    (error) => {
      handleMTrackEnabledError(error);
    }
  );
}

export function getUserTrackerConsentStatus(/*partnerCode = 'NINESPOKES'*/) {
  const { id } = UserManagementStore.getCADetails();
  let url = `${envConfig.apiBaseUrlBusiness}${mTrackConsentEndpoint}/${id}`;
  if (envConfig.isStubsEnabled) {
    url = `${envConfig.apiBaseUrlStub}${mTrackConsentEndpoint}/${id}`;
  }

  ApiUtils.makeAjaxCall(
    {
      apiVersion: config.apiVersions.authServices,
      method: 'GET',
      url,
      addAuthToken: true,
    },
    (body) => {
      if (body.data.consent) {
        handleMTrackConsentedSuccess(body.data.consent);
      } else if (body.error) {
        handleMTrackConsentedError(body);
      } else {
        handleMTrackConsentedError();
      }
    },
    (error) => {
      handleMTrackConsentedError(error);
    }
  );
}

export function createUserTrackerConsent() {
  const { userId, corporateId } = getUserDetails();
  let customerData;
  if (userId && corporateId) {
    customerData = {
      userId,
      customerId: corporateId,
    };
  }

  let url = `${envConfig.apiBaseUrlBusiness}${mTrackCreateConsentEndpoint}`;
  if (envConfig.isStubsEnabled) {
    url = `${envConfig.apiBaseUrlStub}${mTrackCreateConsentEndpoint}`;
  }

  ApiUtils.makeAjaxCall(
    {
      apiVersion: config.apiVersions.authServices,
      method: 'POST',
      url,
      addAuthToken: true,
      requestData: customerData,
    },
    (body) => {
      handleMTrackConsentCreateSuccess(body);
    },
    (error) => {
      handleMTrackConsentCreateError(error);
    }
  );
}

/**
 * Calls the api to retrieve a short term token
 * that will be typically used with third parties
 * @param {Object} data an object containing the
 * data for the short token request
 */
export async function getShortTermToken(partnerCode = 'NINESPOKES') {
  const { context, userId, corporateId } = getUserDetails();

  const baseUrl = envConfig.isStubsEnabled
    ? envConfig.apiBaseUrlStub
    : envConfig.apiBaseUrlBusiness;

  let url = `${baseUrl}${APIPath}/shortterm/${partnerCode}`;

  return new Promise((resolve, reject) => {
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.authServices,
        method: 'POST',
        url,
        addAuthToken: true,
        headers: {
          user_id: userId,
          corporate_id: corporateId,
        },
        requestData: JSON.stringify({
          userId,
          corporateId,
          context,
        }),
      },
      ({ token }) => {
        if (!token) {
          return reject();
        }
        return resolve(token);
      },
      () => {
        return reject();
      }
    );
  });
}

/**
 * Calls the api to retrieve third party redirect URL
 *
 * @param {Object} data an object containing the
 * data for the short token request
 *
 */
export async function getThirdPartyRedirect() {
  let { corporateId, userId } = getUserDetails();

  const baseUrl = envConfig.isStubsEnabled
    ? envConfig.apiBaseUrlStub
    : envConfig.apiBaseUrlBusiness;

  let url = `${baseUrl}${APIPath}/tpredirect`;

  return new Promise((resolve, reject) => {
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.authServices,
        method: 'POST',
        url,
        addAuthToken: true,
        headers: {
          corporate_id: corporateId,
          user_id: userId,
        },
      },
      ({ redirectUrl }) => {
        if (!redirectUrl) {
          return reject();
        }

        return resolve(redirectUrl);
      },
      (err) => {
        return reject();
      }
    );
  });
}
